// =============================================================================
// SALES PAGES LAYOUTS
// =============================================================================

export default {
  path: '/sales',
    component: () => import('../../views/admin/sales/index.vue'),
  children: [
  {
    path: '/',
    redirect: '/error-404'
  },
  {
    path: 'invoices',
    component: () => import('../../views/admin/sales/invoices/index.vue'),
    children: [
      {
        path: '/',
        name: 'saleInvoices',
        component: () => import(/* webpackChunkName: "saleInvoices" */ '../../views/admin/sales/invoices/list/saleInvoicesList.vue'),
        meta: {
          // permission: 'sale_invoice.show',
          pageTitle: '',
          pageTitleI18n: 'sales.invoices.list.title'
          // rule: 'editor'
        }
      },
      {
        path: 'trash',
        name: 'saleInvoiceTrash',
        component: () => import(/* webpackChunkName: "usersTrash" */ '../../views/admin/sales/invoices/trash/saleInvoicesTrash.vue'),
        meta: {
          // permission: 'sale_invoice.delete',
          pageTitle: 'سطل زباله فاکتور فروش',
          pageTitleI18n: 'sales.invoices.trash.title'
          // rule: 'editor'
        }
      },
      {
        path: 'trash/:id',
        name: 'saleInvoiceTrashProfile',
        component: () => import(/* webpackChunkName: "saleInvoiceTrash" */ '../../views/admin/sales/invoices/invoice/saleInvoice.vue'),
        meta: {
          // permission: 'sale_invoice.show',
          pageTitle: '',
          pageTitleI18n: 'sales.invoices.invoice.title'
          // rule: 'editor'
        }
      },
      {
        path: 'insert',
        name: 'insertSaleInvoice',
        component: () => import(/* webpackChunkName: "insertSaleInvoice" */ '../../views/admin/sales/invoices/insert/insertSaleInvoice.vue'),
        meta: {
          // permission: 'sale_invoice.create',
          pageTitle: '',
          pageTitleI18n: 'sales.invoices.insert.title'
          // rule: 'editor'
        }
      },

      {
        path: ':id',
        component: () => import('../../views/admin/sales/invoices/invoice/index'),
        children: [
          {
            path: '/',
            name: 'saleInvoice',
            component: () => import(/* webpackChunkName: "saleInvoice" */ '../../views/admin/sales/invoices/invoice/saleInvoice.vue'),
            meta: {
              // permission: 'sale_invoice.show',
              pageTitle: '',
              pageTitleI18n: 'sales.invoices.invoice.title'
              // rule: 'editor'
            }
          },
          {
            path: 'activities-log',
            name: 'saleInvoiceActivitiesLog',
            component: () => import(/* webpackChunkName: "saleInvoiceActivitiesLog" */ '../../views/admin/sales/invoices/activitiesLog/saleInvoiceActivitiesLog.vue'),
            meta: {
              // permission: 'activity_logs.show',
              pageTitle: 'لاگ های فاکتور فروش',
              pageTitleI18n: 'sales.invoices.invoice.logs.title'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            name: 'editSaleInvoice',
            component: () => import(/* webpackChunkName: "editSaleInvoice" */ '../../views/admin/sales/invoices/edit/editSaleInvoice.vue'),
            meta: {
              // permission: 'sale_invoice.update',
              pageTitle: '',
              pageTitleI18n: 'sales.invoices.edit.title'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
  },
  {
    path: 'return-invoices',
    component: () => import('../../views/admin/sales/returnInvoices/index.vue'),
    children: [
      {
        path: '/',
        name: 'returnSaleInvoices',
        component: () => import(/* webpackChunkName: "returnSaleInvoices" */ '../../views/admin/sales/returnInvoices/list/returnSaleInvoiceList.vue'),
        meta: {
          // permission: 'sale_invoice.show',
          pageTitle: '',
          pageTitleI18n: 'sales.returnInvoices.list.title'
          // rule: 'editor'
        }
      },

      {
        path: ':id',
        component: () => import('../../views/admin/sales/returnInvoices/invoice/index'),
        children: [
          {
            path: '/',
            name: 'returnSaleInvoice',
            component: () => import(/* webpackChunkName: "returnSaleInvoice" */ '../../views/admin/sales/returnInvoices/invoice/returnSaleInvoice.vue'),
            meta: {
              // permission: 'sale_invoice.show',
              pageTitle: '',
              pageTitleI18n: 'sales.returnInvoices.invoice.title'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
  },
  {
    path: 'plans',
    component: () => import('../../views/admin/sales/plans/index.vue'),
    children: [
      {
        path: '',
        name: 'plans',
        component: () => import(/* webpackChunkName: "plans" */ '../../views/admin/sales/plans/list/planList.vue'),
        meta: {
          permission: 'sale_plan.show',
          pageTitle: 'پلن های فروش',
          pageTitleI18n: 'plans.list.title'
          // rule: 'editor'
        }
      },
      {
        path: 'trash',
        name: 'plansTrash',
        component: () => import(/* webpackChunkName: "plansTrash" */ '../../views/admin/sales/plans/trash/planTrash.vue'),
        meta: {
          permission: 'sale_plan.delete',
          pageTitle: 'سطل زباله پلن فروش',
          pageTitleI18n: 'plans.trash.title'
          // rule: 'editor'
        }
      },
      {
        path: 'insert',
        name: 'insertPlan',
        component: () => import(/* webpackChunkName: "insertPlan" */ '../../views/admin/sales/plans/insert/insertPlan.vue'),
        meta: {
          permission: 'sale_plan.create',
          pageTitle: 'ایجاد پلن فروش',
          pageTitleI18n: 'plans.insert.title'
          // rule: 'editor'
        }
      },
      {
        path: ':planId',
        component: () => import('../../views/admin/sales/plans/plan/index.vue'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "plan" */ '../../views/admin/sales/plans/plan/profile/planProfile.vue'),
            name: 'plan',
            meta: {
              permission: 'sale_plan.show',
              pageTitle: 'پلن فروش',
              pageTitleI18n: 'plans.profile.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "editPlan" */ '../../views/admin/sales/plans/edit/editPlan.vue'),
            name: 'editPlan',
            meta: {
              permission: 'sale_plan.update',
              pageTitle: 'ویرایش پلن فروش',
              pageTitleI18n: 'plans.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'apps',
            component: () => import(/* webpackChunkName: "planApps" */ '../../views/admin/sales/plans/plan/apps/planApps.vue'),
            name: 'planApps',
            meta: {
              permission: 'sale_plan.update',
              pageTitle: 'باشگاه های پلن فروش',
              pageTitleI18n: 'plans.apps.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'modules',
            component: () => import(/* webpackChunkName: "planModules" */ '../../views/admin/sales/plans/plan/modules/planModules.vue'),
            name: 'planModules',
            meta: {
              permission: 'sale_plan.show',
              pageTitle: 'محدودیت های پلن فروش',
              pageTitleI18n: 'plans.modules.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'modules/edit',
            component: () => import(/* webpackChunkName: "editPlanModules" */ '../../views/admin/sales/plans/plan/modules/editPlanModules.vue'),
            name: 'editPlanModules',
            meta: {
              permission: 'sale_plan.update',
              pageTitle: 'محدودیت های پلن فروش',
              pageTitleI18n: 'plans.modules.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'addons',
            component: () => import(/* webpackChunkName: "planAddons" */ '../../views/admin/sales/plans/plan/addons/planAddons.vue'),
            name: 'planAddons',
            meta: {
              permission: 'sale_plan.show',
              pageTitle: 'محدودیت های پلن فروش',
              pageTitleI18n: 'plans.modules.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'addons/edit',
            component: () => import(/* webpackChunkName: "editPlanModules" */ '../../views/admin/sales/plans/plan/addons/editPlanAddons.vue'),
            name: 'editPlanAddons',
            meta: {
              permission: 'sale_plan.update',
              pageTitle: 'محدودیت های پلن فروش',
              pageTitleI18n: 'plans.modules.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'activities-log',
            name: 'planActivitiesLog',
            component: () => import(/* webpackChunkName: "planActivitiesLog" */ '../../views/admin/sales/plans/plan/activitiesLog/planActivitiesLog.vue'),
            meta: {
              permission: 'activity_logs.show',
              pageTitle: 'لاگ های پلن فروش',
              pageTitleI18n: 'plans.logs.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
  },
  {
    path: 'customers',
    component: () => import('../../views/admin/sales/customers/index.vue'),
    children: [
      {
        path: '',
        name: 'customersList',
        component: () => import(/* webpackChunkName: "customersList" */ '../../views/admin/sales/customers/list/customersList.vue'),
        meta: {
          // permission: 'sale_plan.show',
          pageTitle: 'لیست مشتریان',
          pageTitleI18n: 'sales.customers.list.title'
          // rule: 'editor'
        }
      },
      {
        path: 'trash',
        name: 'customersTrash',
        component: () => import(/* webpackChunkName: "customersTrash" */ '../../views/admin/sales/customers/trash/customersTrash.vue'),
        meta: {
          // permission: 'sale_plan.delete',
          pageTitle: 'سطل زباله مشتریان',
          pageTitleI18n: 'sales.customers.trash.title'
          // rule: 'editor'
        }
      },
      {
        path: 'insert',
        name: 'insertCustomer',
        component: () => import(/* webpackChunkName: "insertCustomer" */ '../../views/admin/sales/customers/insert/insertCustomer.vue'),
        meta: {
          // permission: 'sale_plan.create',
          pageTitle: 'ایجاد مشتری',
          pageTitleI18n: 'sales.customers.insert.title'
          // rule: 'editor'
        }
      },
      {
        path: ':customerId',
        component: () => import('../../views/admin/sales/customers/customer/index.vue'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "customer" */ '../../views/admin/sales/customers/customer/profile/customerProfile.vue'),
            name: 'customer',
            meta: {
              // permission: 'sale_plan.show',
              pageTitle: 'پلن فروش',
              pageTitleI18n: 'sales.customers.profile.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "editCustomer" */ '../../views/admin/sales/customers/edit/editCustomer.vue'),
            name: 'editCustomer',
            meta: {
              // permission: 'sale_plan.update',
              pageTitle: 'ویرایش مشتری',
              pageTitleI18n: 'sales.customers.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          {
            path: 'activities-log',
            name: 'customerActivitiesLog',
            component: () => import(/* webpackChunkName: "customerActivitiesLog" */ '../../views/admin/sales/customers/customer/activitiesLog/customerActivitiesLog.vue'),
            meta: {
              permission: 'activity_logs.show',
              pageTitle: 'لاگ های مشتری',
              pageTitleI18n: 'sales.customers.logs.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          }
        ]
      }
    ]
  },
  {
    path: 'subscriptions',
    component: () => import('../../views/admin/sales/subscription/index.vue'),
    children: [
      {
        path: '',
        name: 'subscriptionsList',
        component: () => import(/* webpackChunkName: "subscriptionsList" */ '../../views/admin/sales/subscription/list/subscriptionsList.vue'),
        meta: {
          permission: 'app_subscription.show',
          pageTitle: 'اشتراک های فروش',
          pageTitleI18n: 'subscriptions.list.title'
          // rule: 'editor'
        }
      },
      {
        path: ':subscriptionId',
        component: () => import('../../views/admin/sales/subscription/profile/index.vue'),
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "subscriptionProfile" */ '../../views/admin/sales/subscription/profile/appSubscription.vue'),
            name: 'subscriptionProfile',
            meta: {
              permission: 'app_subscription.show',
              pageTitle: 'اشتراک',
              pageTitleI18n: 'subscriptions.subscription.title'
              // rule: 'editor'
            }
          },
          {
            path: 'edit',
            component: () => import(/* webpackChunkName: "editSubscription" */ '../../views/admin/sales/subscription/edit/editAppSubscription.vue'),
            name: 'editSubscription',
            meta: {
              permission: 'app_subscription.update',
              pageTitle: 'ویرایش اشتراک',
              pageTitleI18n: 'subscriptions.edit.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          },
          /*{
            path: 'activities-log',
            name: 'subscriptionActivitiesLog',
            component: () => import(/!* webpackChunkName: "subscriptionActivitiesLog" *!/ '../../views/admin/sales/plans/plan/activitiesLog/planActivitiesLog.vue'),
            meta: {
              permission: 'activity_logs.show',
              pageTitle: 'لاگ های پلن فروش',
              pageTitleI18n: 'plans.logs.title',
              layoutStatus: 'profile'
              // rule: 'editor'
            }
          }*/
        ]
      }
    ]
  },
]
}
